export const FOLLOWERS_OR_FOLLOWING_PAGE_SIZE = 12
